const maxLogBuffer = 50
const maxLogSaveDelay = 600

let empty = () => {}
let oldConsole = {
  log: console.log || empty,
  info: console.info || empty,
  warn: console.warn || empty,
  debug: console.debug || empty,
  error: console.error || empty,
  trace: console.trace || empty,
  table: console.table || empty,
  dir: console.dir || empty,
  _exception: console._exception || empty,

  group: console.group || empty,
  groupCollapsed: console.groupCollapsed || empty,
  groupEnd: console.groupEnd || empty,

  assert: console.assert || empty,
  count: console.count || empty,

  time: console.time || empty,
  timeEnd: console.timeEnd || empty
}


let localConsole = {}
for(var k in oldConsole) {
  localConsole[k] = oldConsole[k].bind(console)
}

function guid() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1)
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4()
}

let windowId = guid()

let savedLogs = []
let groupStack = []
let savingLogs = false

let tags = []

let lastLogSave = 0

let logDestinations = []

let passwords = new Map()

function ajaxSave(logs, path) {
  return new Promise((resolve,reject) => {
    let xHttp
    xHttp=new XMLHttpRequest()
    xHttp.addEventListener('load', () => {
      try {
        let response = JSON.parse(xHttp.responseText)
        if(response.error) return reject(response.error)
        resolve(response)
      } catch(e) {
        reject(e ? e.message || e : e)
      }
    })
    xHttp.addEventListener('error', () => {
      reject(xHttp.statusText)
    })
    xHttp.open("POST", path, true);
    xHttp.setRequestHeader("Content-type", "application/json");
    xHttp.send(JSON.stringify({
      type: "save",
      windowId,
      sessionId: localStorage.sessionId,
      logs,
      tags
    }))
  })
}

function addTag(...ts) {
  ts = ts.filter(t => tags.indexOf(t) == -1)
  if(ts.length != 0) return;
  tags=tags.concat(ts)
  saveLog({type:"tagAdd", tag: t})
  doSaveLogs()
}

function doSaveLogs(retry = 0) {
  //localConsole.log("DO SAVE LOGS", savedLogs, savingLogs)
  if(savingLogs) return;
  if(savedLogs.length == 0) return;
  savingLogs = true;
  lastLogSave = Date.now()
  let saveCount = savedLogs.length

  let savePromises = logDestinations.map(
    dest => dest(savedLogs.slice())
  )
  Promise.all(savePromises).then(
    saved => {
      //localConsole.log("LOGS SAVED", saveCount)
      savedLogs.splice(0, saveCount)
      savingLogs = false
    }
  ).catch(error => {
    localConsole.log("LOGS SAVE ERROR", error)
    savingLogs = false
    setTimeout(() => doSaveLogs(retry + 1), Math.min(2000, 200*Math.pow(2, retry)))
  })
}



function removePasswords(obj) {
  switch(typeof obj) {
    case 'object':
      for(let k in obj) obj[k]=removePasswords(obj[k])
      return obj
    case 'string':
      for(let password of passwords.values()) {
        obj = obj.replace(password, "***PASSWORD***")
      }
      return obj
    default:
      return obj
  }
}

function escapeRegExp(str) {
  return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&"); // $& means the whole matched string
}

function addPassword(password) {
  passwords.set(password, new RegExp(escapeRegExp(password), "g"))
}

function removePassword(password) {
  passwords.delete(password)
}

function saveLog(...logs) {
  logs.forEach(log => {
    log.timestamp = Date.now()
    log.group = groupStack
    removePasswords(log)
  })
  savedLogs.push(...logs)
  if(!lastLogSave) lastLogSave = Date.now()
  if(savedLogs.length > maxLogBuffer || Date.now() - lastLogSave > maxLogSaveDelay) {
    doSaveLogs()
  }
  setTimeout(() => {
    if(savedLogs.length>0 && Date.now() - lastLogSave > maxLogSaveDelay) {
      doSaveLogs()
    }
  }, maxLogSaveDelay+22)
}

function normalizeObject(data) {
  try {
    let text = JSON.stringify(data)
    if(text.length > 255) return data.toString()
    return JSON.parse(text)
  } catch(e) {
    return data.toString()
  }
}

function prepareArg(arg) {
  if(typeof arg == 'string') return arg
  if(typeof arg == 'number') return arg
  if(arg instanceof Error) return {
    type: 'error',
    message: arg.message,
    stack: arg.stack
  }
  return normalizeObject(arg)
}

function getStackTrace() {
  try {
    throw new Error("trace")
  } catch(e) {
    return e.stack
  }
}

function messageLogger(typeName, next, trace) {
  return (...args) => {
    let log = {
      type: typeName,
      message: args.map(prepareArg),
    }
    if(trace) log.trace = getStackTrace()
    saveLog(log)
    //localConsole.log("LOG SAVED!", log)
    if(next) next(...args)
  }
}



var counters = new Map()

function install() {
  let messageFunctions = ['log','info','warn','debug','dir','table']
  for(let funcName of messageFunctions) console[funcName] = messageLogger(funcName,
    (...args)=>oldConsole[funcName].call(console, ...args))
  let traceFunctions = ['trace','error','_exception']
  for(let funcName of traceFunctions) console[funcName] = messageLogger(funcName,
    (...args)=>oldConsole[funcName].call(console, ...args), true)

  console.group = (groupName) => {
    groupStack.push(groupName)
    oldConsole.group.call(console, groupName)
    saveLog({type: "group", group: groupName, collapsed: false})
  }
  console.groupCollapsed = (groupName) => {
    groupStack.push(groupName)
    oldConsole.group.call(console, groupName)
    saveLog({type: "group", group: groupName, collapsed: true})
  }
  console.groupEnd = () => {
    groupStack.pop()
    oldConsole.group.call(console)
    saveLog({type: "groupEnd"})
  }

  console.count = (label) => {
    let counter = counters.get(label)
    counter++
    saveLog({type:"count", label: label, count: counter})
    counters.set(label, counter)
    oldConsole.count.call(console, label)
  }

  console.assert = (expr, ...msg) => {
    if(!expr) {
      saveLog({ type:"assertionFailed", message: msg.map(prepareArg) })
    }
    oldConsole.assert.call(console, expr, ...msg)
  }

  var timers = new Map()

  console.time = (label) => {
    timers.set(label, Date.now())
    oldConsole.time.call(console, label)
  }

  console.timeEnd = (label) => {
    let timer = timers.get(label) || Date.now()
    timers.delete(label)
    saveLog({type:"timer", label, time: Date.now() - timer })
    oldConsole.timeEnd.call(console, label)
  }

  localConsole.log("LOGGER INSTALLED")
}

let lagDetectors = new Map()

function stopLagDetector(title, timeout) {
  //localConsole.error("STOP LAG DETECTOR", title)
  if(!timeout) console.timeEnd(title)
  let detector = lagDetectors.get(title)
  if(!detector) return
  clearTimeout(detector.timeout)
  if(Date.now() - detector.start > detector.maxDuration) {
    console.error("LAG DETECTED", title)
    addTag(title+'-lag')
  }
  lagDetectors.delete(title)
}

function startLagDetector(title, maxDuration) {
  //localConsole.error("START LAG DETECTOR", title)
  console.time(title)
  if(lagDetectors.has(title)) stopLagDetector(title)
  let detector = {
    title,
    maxDuration,
    start: Date.now(),
    timeout: setTimeout(() => stopLagDetector(title, true), maxDuration+23)
  }
  lagDetectors.set(title, detector)
}

function addAjaxLogDestination(path) {
  logDestinations.push((logs) => ajaxSave(logs, path))
}
function addWorkerParentLogDestination() {
  logDestinations.push((logs) => {
    postMessage({
      type: "logs",
      logs
    })
  })
}

let logger = {
  localConsole,
  addTag,
  install,
  startLagDetector,
  stopLagDetector,
  tags,
  saveLog,
  addAjaxLogDestination,
  addWorkerParentLogDestination,
  addPassword,
  removePassword
}

if(typeof window != "undefined" ) {
  window.logger = logger
}

export default logger



// WEBPACK FOOTER //
// ./src/logger/index.js